import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RootState } from '../../app.module';
import { OdometerState } from './odometer.types';

export const odometerFeature = createFeatureSelector<RootState, OdometerState>('odometer');
export const odometerTableDataSelector = createSelector(odometerFeature, (state) => state.tableData);
export const odometerRowData = createSelector(odometerTableDataSelector, (state) => state.rows);
